export default __webpack_public_path__ + "static/media/kartu-1.e6fc0000.jpg";